import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5fccbf06&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BusinessDetails: require('/codebuild/output/src195787613/src/cc-portal/components/BusinessDetails.vue').default,BusinessAddress: require('/codebuild/output/src195787613/src/cc-portal/components/BusinessAddress.vue').default,Accountant: require('/codebuild/output/src195787613/src/cc-portal/components/Accountant.vue').default,CommonBenefieciaryShareHolder: require('/codebuild/output/src195787613/src/cc-portal/components/CommonBenefieciaryShareHolder.vue').default})
